import { resolveBookingWebsite } from '../../../requests-module/src/config/partnerIdMappings';

export interface InitBookingRequest {
    lihe_id?: number;
    participants: string;
    start_date: string;
    end_date: string;
    prestations?: string;
    pack_code?: string;
    season: string;
    prest_id: string;
    origin?: string;
    destination?: string;
    website: string;
    services?: string;
    destinationStationId?: string | null;
}

function resolveInitWebsite(queryParams: Record<string, string | undefined>): string {
    const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
    const partnerId = queryParams.wpid || urlParams?.get('wpid') || undefined;

    return resolveBookingWebsite({
        website: queryParams.website || urlParams?.get('website') || undefined,
        partnerId,
        hostname: (window.env && window.env.VUE_APP_WEBSITE) || window.location.hostname,
    });
}


export function createRequestData(queryParams: any): InitBookingRequest {
    const isTNE = queryParams.prest_id === 'TNE';

    const requiredParams = isTNE
        ? ['participants', 'start_date', 'end_date', 'prest_id']
        : ['lihe_id', 'participants', 'start_date', 'end_date', 'prestations', 'prest_id'];
    const missingParams = requiredParams.filter(param => !queryParams[param]);

    if (missingParams.length > 0) {
        throw new Error(`Missing required query parameters: ${missingParams.join(', ')}`);
    }

    const result: InitBookingRequest = {
        participants: queryParams.participants,
        start_date: queryParams.start_date,
        end_date: queryParams.end_date,
        season: queryParams.season,
        prest_id: queryParams.prest_id,
        website: resolveInitWebsite(queryParams)
    };

    if (queryParams.lihe_id) result.lihe_id = parseInt(queryParams.lihe_id);
    if (queryParams.prestations) result.prestations = queryParams.prestations;
    if (queryParams.pack_code) result.pack_code = queryParams.pack_code;
    if (queryParams.origin) result.origin = queryParams.origin;
    if (queryParams.destination) result.destination = queryParams.destination;
    if (queryParams.services) result.services = queryParams.services;
    if (queryParams.destinationStationId != null && queryParams.destinationStationId !== '') {
        result.destinationStationId = queryParams.destinationStationId;
    }

    return result;
}